import { useState } from 'react'
import { ModalForm } from '@ant-design/pro-components'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App, Button, Form, Input, Select } from 'antd'
import { useTRPC } from '@/trpc/react.ts'
import { FinanceSelect } from './finance-select.tsx'

export function PayeeQuickCreate({
  value,
  onChange,
  id
}: {
  value?: number
  onChange?: (value?: number) => void
  id?: string
}) {
  const [open, setOpen] = useState(false)
  const trpc = useTRPC(),
    cache = useQueryClient(),
    { message } = App.useApp()
  const save = useMutation(trpc.bill.savePayee.mutationOptions())
  return (
    <>
      <div className="grid grid-cols-[1fr_auto] gap-2">
        <FinanceSelect purpose="payee.read" id={id} kind="payee" value={value} onChange={onChange} />
        <Button onClick={() => setOpen(true)}>新增对象</Button>
      </div>
      {open && (
        <ModalForm<{ name: string; entityKind: 'person' | 'organization'; note?: string }>
          name="payee-quick-create"
          open
          title="新增付款对象"
          layout="vertical"
          width="32rem"
          initialValues={{ entityKind: 'person' }}
          modalProps={{ destroyOnHidden: true, onCancel: () => setOpen(false) }}
          submitter={{
            submitButtonProps: { loading: save.isPending },
            resetButtonProps: { onClick: () => setOpen(false) }
          }}
          onFinish={async (values) => {
            try {
              const saved = await save.mutateAsync({
                ...values,
                sourceType: 'external',
                customerId: null,
                memberId: null,
                isEnabled: true,
                note: values.note ?? null
              })
              await cache.invalidateQueries(trpc.bill.directoryOptions.queryFilter({ kind: 'payee' }))
              onChange?.(saved.id)
              setOpen(false)
              return true
            } catch (error) {
              void message.error(error instanceof Error ? error.message : '保存失败')
              return false
            }
          }}
        >
          <Form.Item name="name" label="付款对象名称" rules={[{ required: true, whitespace: true }]}>
            <Input maxLength={255} />
          </Form.Item>
          <Form.Item name="entityKind" label="对象类型" rules={[{ required: true }]}>
            <Select
              options={[
                { value: 'person', label: '个人' },
                { value: 'organization', label: '单位' }
              ]}
            />
          </Form.Item>
          <Form.Item name="note" label="备注">
            <Input.TextArea maxLength={5000} />
          </Form.Item>
        </ModalForm>
      )}
    </>
  )
}
